import React from 'react';
import { JSONLD } from '../../../../components/JSONLD';
import { createSchemaFaq } from '../../../../seo-schemas/faq';
import { healthFaqsData } from '../../../../data/health-faqs';
export const HealthSchemas = () => <>
    <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="index.tsx">
      {createSchemaFaq({
      entities: healthFaqsData.map(faqData => ({
        question: faqData.header,
        answer: Array.isArray(faqData.body) ? faqData.body.join(' ') : faqData.body
      }))
    })}
    </JSONLD>
  </>;